import { signOut as amplifySignOut } from 'aws-amplify/auth'

import performSignOutCleanup from './signOutCleanup'

export async function adminSignOut() {
  try {
    await amplifySignOut()
  } catch (error) {
    console.warn('Cognito sign-out failed', error)
  }

  // Scheduler `?token=` sessions have no Cognito session, so the Hub event never arrives.
  performSignOutCleanup()
}
